import React from 'react';
import Banner from '../../components/Banner/banner';
import VideoFacade from '../../components/VideoFacade/VideoFacade';
import SEO from '../../components/SEO/SEO';
import imgBanner from '../../assets/img/slider-pagina-publicidad.png';
import voImage from '../../assets/img/Laura-Candela-Micro.jpg';
import { useTranslation } from 'react-i18next';
import './vo.scss';

const Vo = () => {
  const [t] = useTranslation('global');

  const reelShowcase = [
    { src: 'https://player.vimeo.com/video/521908508?h=fe5183deff', title: 'Commercial Reel 1' },
    { src: 'https://player.vimeo.com/video/521887751?h=c34557b50d', title: 'Commercial Reel 2' },
    { src: 'https://player.vimeo.com/video/521884966?h=381ff7cb8a', title: 'Commercial Reel 3' }
  ];

  const voiceoverClips = [
    { src: 'https://player.vimeo.com/video/329154462?h=3970cac14c', title: 'Voiceover Work 1' },
    { src: 'https://player.vimeo.com/video/386662398?h=e479502070', title: 'Voiceover Work 2' },
    { src: 'https://www.youtube.com/embed/tAC73QRy-Yw', title: 'Voiceover Work 3' },
    { src: 'https://www.youtube.com/embed/HOWx4vhl1Xg', title: 'Voiceover Work 4' },
    { src: 'https://www.youtube.com/embed/5rCgeJEJ5Ow', title: 'Voiceover Work 5' },
    { src: 'https://www.youtube.com/embed/9S5z3CTBPWU', title: 'Voiceover Work 6' },
    { src: 'https://www.youtube.com/embed/0VVB9Fu6xLI', title: 'Voiceover Work 7' },
    { src: 'https://www.youtube.com/embed/WcQoWacslJM', title: 'Voiceover Work 8' },
    { src: 'https://www.youtube.com/embed/Ac8J--71zQc', title: 'Voiceover Work 9' }
  ];

  return (
    <main className="globalContainer">
      <SEO title={t('Nav.Vo')} canonicalPath="/vo" />

      <Banner name={imgBanner} alt="Laura Candela Voiceover & Advertising" />

      <section className="globalSection" aria-label="Voiceover and Commercial Reels">
        <h1 className="sectionTitle">{t('Reels')}</h1>

        {/* Main Reel with Image Facade */}
        <div className="mainReelWrapper">
          <VideoFacade
            src="https://player.vimeo.com/video/672816615?h=83268bff13"
            title="Laura Candela Main Voiceover Reel"
          />
        </div>

        {/* Commercial Reels Grid */}
        <div className="videoGridContainer reelsThreeCol">
          {reelShowcase.map((reel, index) => (
            <div key={index} className="videoGridItem">
              <VideoFacade src={reel.src} title={`Laura Candela - ${reel.title}`} />
            </div>
          ))}
        </div>

        <h2 className="sectionTitle">{t('Nav.Vo')}</h2>

        {/* Voiceover Works Grid */}
        <div className="videoGridContainer">
          {voiceoverClips.map((clip, index) => (
            <div key={index} className="videoGridItem">
              <VideoFacade src={clip.src} title={`Laura Candela - ${clip.title}`} />
            </div>
          ))}
        </div>
      </section>

      {/* Voiceover & Dubbing Background Section */}
      <section className="dataContainer brief" aria-label="Voiceover Background">
        <div className="dataContentWrapper">
          <img
            className="dataImage"
            src={voImage}
            alt="Laura Candela in Studio"
            loading="lazy"
          />
          <article className="briefP">
            <h2 className="dataTitle">{t('LocutionTitle')}</h2>
            <p className="paragraf">{t('LocutionText1')}</p>
            <p className="paragraf">{t('LocutionText2')}</p>
            <p className="paragraf">{t('LocutionText3')}</p>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Vo;